import React from 'react';
import { findDOMNode } from 'react-dom';
import Classnames from 'classnames';
import PropTypes from 'prop-types';

export default class extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    format: String,
    className: '',
    tabIndex: -1,

    min: null,
    max: null,
    step: 1,
  };

  state = { editing: false };

  // focus(node) {
  //   if (!node) return;
  //   node.focus()
  //   node.select()
  // }

  render() {
    const { value, format, tabIndex, className, min, max, step } = this.props;
    const { onChange } = this.props;
    const { editing, currentValue } = this.state;

    return (
      <input
        className={Classnames(className, 'number-field', value < 1e-6 && 'is-zero')}
        // ref={this.focus}
        tabIndex={tabIndex}
        value={editing ? currentValue : format(value)}
        onChange={event => {
          let newValue = Math.round(100 * +event.target.value.replace(",",""))/100;
          this.setState({ currentValue: newValue });
          if (isNaN(newValue)) return;

          if (min != null) newValue = Math.max(min, newValue);
          if (max != null) newValue = Math.min(max, newValue);
          onChange && onChange(newValue);
        }}
        onFocus={() => {
          this.setState({ editing: true, currentValue: format(value) });
          findDOMNode(this).select();
        }}
        onBlur={() => this.setState({ editing: false })}
        onKeyDown={event => {
          if (event.key === 'Enter') {
            onChange && onChange(event.target.value);
            this.setState({ editing: false });
          } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            let newStep = step * (event.key === 'ArrowUp' ? 1 : -1);
            if (event.metaKey) newStep *= 100;
            else if (event.shiftKey) newStep *= 10;
            else if (event.altKey) newStep *= 0.1;

            let newValue = +value + newStep;
            if (min != null) newValue = Math.max(min, newValue);
            if (max != null) newValue = Math.min(max, newValue);

            this.setState({ currentValue: newValue });
            onChange && onChange(format(newValue));
            event.preventDefault();
          }
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CompositionTable/EditableValue.js